'use client';
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// components/button/react/src/version.ts
var name = "@gs-ux-uitoolkit-react/button";
var version = "18.12.1                 ".trim();
var Version = { name, version };

// components/button/react/src/analytics-tracking.ts
import { ComponentAnalytics } from "@gs-ux-uitoolkit-react/analytics";
var componentAnalytics = new ComponentAnalytics({
  packageName: Version.name,
  version: Version.version
});
componentAnalytics.trackPackageLoad();

// components/button/react/src/index.ts
import { buttonActionTypes, buttonEmphasises as buttonEmphasises2, buttonGroupOrientations as buttonGroupOrientations2, buttonGroupStyleSheet as buttonGroupStyleSheet2, buttonSelectSizes as buttonSelectSizes2, buttonSelectStyleSheet as buttonSelectStyleSheet2, buttonSelectTypes as buttonSelectTypes2, buttonShapes as buttonShapes2, buttonSizeVariants, buttonSizes as buttonSizes3, buttonStatuses as buttonStatuses2, buttonStyleSheet as buttonStyleSheet2, buttonTypes as buttonTypes2, defaultButtonGroupContext as defaultButtonGroupContext2, defaultButtonGroupProps as defaultButtonGroupProps2, defaultButtonProps as defaultButtonProps2, defaultButtonSelectProps as defaultButtonSelectProps2, getButtonClassNames as getButtonClassNames2, getButtonGroupClassNames as getButtonGroupClassNames2, getButtonSelectInputClassNames as getButtonSelectInputClassNames2, getButtonSelectLabelClassNames as getButtonSelectLabelClassNames2, getButtonSelectRootClassNames as getButtonSelectRootClassNames2, getButtonSelectTargetClassNames as getButtonSelectTargetClassNames2, getRootClassNames as getRootClassNames2 } from "@gs-ux-uitoolkit-common/button";

// components/button/react/src/button/button.tsx
import { PureComponent, createRef } from "react";
import PropTypes from "prop-types";
import {
  buttonStyleSheet,
  getRootClassNames,
  getButtonClassNames,
  defaultButtonProps,
  buttonStatuses,
  buttonEmphasises,
  buttonSizes,
  buttonShapes,
  buttonTypes
} from "@gs-ux-uitoolkit-common/button";

// components/button/react/src/button-group/button-group-context.tsx
import { createContext } from "react";
import { defaultButtonGroupContext } from "@gs-ux-uitoolkit-common/button";
var ButtonGroupContext = createContext(__spreadValues({}, defaultButtonGroupContext));

// components/button/react/src/button/button.tsx
import { splitDataAttributes, wrapTextChildrenInSpan } from "@gs-ux-uitoolkit-react/shared";
import { ThemeConsumer } from "@gs-ux-uitoolkit-react/theme";
import { EmotionInstanceContext } from "@gs-ux-uitoolkit-react/style";
import { jsx } from "react/jsx-runtime";
var Button = class extends PureComponent {
  constructor(props) {
    super(props);
    this.attachRefs = (buttonEl) => {
      this.htmlButton.current = buttonEl;
      if (typeof this.props.elementRef === "function") {
        this.props.elementRef(buttonEl);
      } else if (this.props.elementRef) {
        this.props.elementRef.current = buttonEl;
      }
    };
    this.htmlButton = createRef();
  }
  componentDidMount() {
    componentAnalytics.trackRender({ officialComponentName: "button" });
  }
  render() {
    const _a = this.props, {
      actionType = defaultButtonProps.actionType,
      status = defaultButtonProps.status,
      emphasis = defaultButtonProps.emphasis,
      size,
      shape = defaultButtonProps.shape,
      type = defaultButtonProps.type,
      disabled = defaultButtonProps.disabled,
      autoFocus = defaultButtonProps.autoFocus,
      name: name2,
      value = defaultButtonProps.value,
      active = defaultButtonProps.active,
      children,
      className,
      classes: overrideClasses,
      elementRef,
      tabIndex,
      style,
      title,
      id,
      buttonId,
      buttonAttrs
    } = _a, otherProps = __objRest(_a, [
      "actionType",
      "status",
      "emphasis",
      "size",
      "shape",
      "type",
      "disabled",
      "autoFocus",
      "name",
      "value",
      "active",
      "children",
      "className",
      "classes",
      "elementRef",
      "tabIndex",
      "style",
      "title",
      "id",
      "buttonId",
      "buttonAttrs"
    ]);
    const internal = {
      name: name2 || this.context.name || defaultButtonProps.name,
      size: size || this.context.size || defaultButtonProps.size
    };
    const { split: dataAttributeProps, remaining: buttonProps } = splitDataAttributes(otherProps);
    return jsx(EmotionInstanceContext.Consumer, { children: (emotionInstance) => jsx(ThemeConsumer, { children: (theme) => {
      const cssClasses = buttonStyleSheet.mount(
        this,
        {
          theme,
          actionType,
          status,
          emphasis,
          size: internal.size,
          shape,
          active,
          disabled
        },
        emotionInstance
      );
      const rootClasses = getRootClassNames({
        cssClasses,
        overrideClasses,
        className
      });
      const buttonClasses = getButtonClassNames({
        cssClasses,
        overrideClasses
      });
      return (
        // wrapping the button in a <span> to mimic the angular button's host el simplifies the styling rules
        jsx(
          "span",
          __spreadProps(__spreadValues({}, __spreadValues({ style, title, id }, dataAttributeProps)), {
            "data-gs-uitk-component": "button",
            "data-action-type": actionType,
            "data-emphasis": emphasis,
            className: rootClasses,
            children: jsx(
              "button",
              __spreadProps(__spreadValues(__spreadValues({}, buttonAttrs), buttonProps), {
                id: buttonId,
                "data-cy": "gs-uitk-button__button",
                "data-action-type": actionType,
                "data-emphasis": emphasis,
                "data-size": internal.size,
                "data-shape": shape,
                "data-status": status,
                "data-active": active,
                className: buttonClasses,
                ref: this.attachRefs,
                type,
                disabled,
                autoFocus,
                tabIndex,
                name: internal.name,
                value,
                children: wrapTextChildrenInSpan(children)
              })
            )
          })
        )
      );
    } }) });
  }
  componentWillUnmount() {
    buttonStyleSheet.unmount(this);
  }
  /**
   * Function used to focus the button component.
   * @public
   */
  focus() {
    const button = this.htmlButton.current;
    if (button) {
      button.focus();
    }
  }
  /**
   * Function used to blur (unfocus) the button component.
   * @public
   */
  blur() {
    const button = this.htmlButton.current;
    if (button) {
      button.blur();
    }
  }
};
Button.contextType = ButtonGroupContext;
Button.propTypes = {
  actionType: PropTypes.oneOf([
    "primary",
    "secondary",
    "destructive",
    "info",
    "contrast"
  ]),
  buttonId: PropTypes.string,
  status: PropTypes.oneOf(buttonStatuses),
  emphasis: PropTypes.oneOf(buttonEmphasises),
  size: PropTypes.oneOf(buttonSizes),
  shape: PropTypes.oneOf(buttonShapes),
  type: PropTypes.oneOf(buttonTypes),
  disabled: PropTypes.bool,
  autoFocus: PropTypes.bool,
  name: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.array]),
  onClick: PropTypes.func,
  onMouseDown: PropTypes.func,
  onMouseUp: PropTypes.func
};

// components/button/react/src/button-select/button-select.tsx
import { PureComponent as PureComponent2, createRef as createRef2 } from "react";
import PropTypes2 from "prop-types";
import {
  buttonSelectStyleSheet,
  getButtonSelectRootClassNames,
  getButtonSelectLabelClassNames,
  getButtonSelectInputClassNames,
  getButtonSelectTargetClassNames,
  defaultButtonSelectProps,
  buttonSelectTypes,
  buttonSelectSizes
} from "@gs-ux-uitoolkit-common/button";
import { splitDataAttributes as splitDataAttributes2, wrapTextChildrenInSpan as wrapTextChildrenInSpan2 } from "@gs-ux-uitoolkit-react/shared";
import { RadioGroupService, getRadioUid } from "@gs-ux-uitoolkit-common/radio";
import { EmotionInstanceContext as EmotionInstanceContext2 } from "@gs-ux-uitoolkit-react/style";
import { ThemeConsumer as ThemeConsumer2 } from "@gs-ux-uitoolkit-react/theme";
import { v4 as uuid } from "uuid";
import { jsx as jsx2, jsxs } from "react/jsx-runtime";
var ButtonSelect = class extends PureComponent2 {
  constructor(props) {
    super(props);
    this.radioGroup = RadioGroupService.instance;
    // Tracks whether the button (in single mode) has changed on click:
    this.inputElChecked = false;
    this.onRadioGroupClick = (uid) => {
      if (this.isControlled()) {
        this.inputElChecked = !!this.props.selected;
      } else if (this.uid !== uid) {
        if (this.htmlInput.current) {
          this.inputElChecked = this.htmlInput.current.checked;
        }
      }
    };
    this.onInternalClick = (event) => {
      if (this.props.onClick) {
        this.props.onClick(event);
      }
      if (!event.isDefaultPrevented()) {
        this.handleChange(event);
      }
    };
    this.htmlInput = createRef2();
    this.uid = getRadioUid();
    this.state = {
      nameUuid: void 0
    };
  }
  componentDidMount() {
    this.inputElChecked = !!this.htmlInput.current.checked;
    this.addToRadioGroup();
    componentAnalytics.trackRender({ officialComponentName: "other" });
    this.setState({
      nameUuid: uuid()
    });
  }
  componentDidUpdate(prevProps) {
    if (prevProps.name !== this.props.name) {
      this.removeFromRadioGroup(prevProps.name);
      this.addToRadioGroup();
    }
  }
  componentWillUnmount() {
    buttonSelectStyleSheet.unmount(this);
    this.removeFromRadioGroup(this.props.name);
  }
  addToRadioGroup() {
    if (this.props.name && this.isSingle()) {
      this.radioGroup.addRadio(this.props.name, this.onRadioGroupClick);
    }
  }
  removeFromRadioGroup(name2) {
    if (name2) {
      this.radioGroup.removeRadio(name2, this.onRadioGroupClick);
    }
  }
  handleChange(event) {
    const { name: name2, value, selected, onChange } = this.props;
    if (this.isSingle() && name2) {
      this.radioGroup.clickRadio(name2, this.uid);
    }
    if (onChange && (this.isMulti() || this.isSingle() && !this.inputElChecked)) {
      Object.assign(event, {
        selected: this.isSingle() ? true : this.htmlInput.current.checked,
        name: name2,
        value
      });
      event.persist();
      onChange(event);
      if (this.isSingle() && !this.inputElChecked) {
        if (!this.isControlled()) {
          this.inputElChecked = true;
        }
      }
    }
    if (this.isControlled()) {
      this.htmlInput.current.checked = !!selected;
    }
  }
  /**
   * Avoids this React error:
   * ```
   * Warning: Failed prop type: You provided a `checked` prop to a form field
   * without an `onChange` handler. This will render a read-only field. If the
   * field should be mutable use `defaultChecked`. Otherwise, set either
   * `onChange` or `readOnly`.
   * ```
   */
  onInternalChange() {
  }
  isControlled() {
    return this.props.selected != void 0;
  }
  isSingle() {
    return !this.isMulti();
  }
  isMulti() {
    return this.props.type === "multi";
  }
  render() {
    const _a = this.props, {
      type,
      size,
      selected,
      defaultSelected,
      children,
      className,
      classes: overrideClasses,
      onChange = () => {
      },
      onClick = () => {
      },
      name: name2,
      style,
      title,
      id
    } = _a, otherProps = __objRest(_a, [
      "type",
      "size",
      "selected",
      "defaultSelected",
      "children",
      "className",
      "classes",
      "onChange",
      "onClick",
      "name",
      "style",
      "title",
      "id"
    ]);
    const internal = {
      name: name2 || this.context.name || this.state.nameUuid,
      size: size || this.context.size || defaultButtonSelectProps.size
    };
    if (!type) {
      throw new Error(
        "<ButtonSelect /> error: 'type' input is required, please provide one!"
      );
    }
    const inputType = type === "multi" ? "checkbox" : "radio";
    const { split: dataAttributeProps, remaining: inputProps } = splitDataAttributes2(otherProps);
    return jsx2(EmotionInstanceContext2.Consumer, { children: (emotionInstance) => jsx2(ThemeConsumer2, { children: (theme) => {
      const cssClasses = buttonSelectStyleSheet.mount(
        this,
        {
          theme,
          size: internal.size
        },
        emotionInstance
      );
      const rootClasses = getButtonSelectRootClassNames({
        cssClasses,
        overrideClasses,
        className
      });
      const labelClasses = getButtonSelectLabelClassNames({
        cssClasses,
        overrideClasses
      });
      const inputClasses = getButtonSelectInputClassNames({
        cssClasses,
        overrideClasses
      });
      const targetClasses = getButtonSelectTargetClassNames({
        cssClasses,
        overrideClasses
      });
      return jsx2(
        "span",
        __spreadProps(__spreadValues({}, __spreadValues({ style, title, id }, dataAttributeProps)), {
          "data-gs-uitk-component": "button-select",
          "data-size": internal.size,
          className: rootClasses,
          children: jsxs(
            "label",
            {
              className: labelClasses,
              "data-cy": "gs-uitk-button-select__label",
              children: [
                jsx2(
                  "input",
                  __spreadProps(__spreadValues({}, inputProps), {
                    name: internal.name,
                    ref: this.htmlInput,
                    type: inputType,
                    checked: selected,
                    onClick: this.onInternalClick,
                    onChange: this.onInternalChange,
                    defaultChecked: (
                      // defaultChecked should only be set if checked is not set;
                      // i.e., if the input is uncontrolled.
                      selected === void 0 ? defaultSelected : void 0
                    ),
                    className: inputClasses,
                    "data-cy": "gs-uitk-button-select__input"
                  })
                ),
                jsx2(
                  "span",
                  {
                    className: targetClasses,
                    "data-cy": "gs-uitk-button-select__target",
                    children: wrapTextChildrenInSpan2(children)
                  }
                )
              ]
            }
          )
        })
      );
    } }) });
  }
  /**
   * Function used to focus the button component.
   * @public
   */
  focus() {
    const input = this.htmlInput.current;
    if (input) {
      input.focus();
    }
  }
  /**
   * Function used to blur (unfocus) the button component.
   * @public
   */
  blur() {
    const input = this.htmlInput.current;
    if (input) {
      input.blur();
    }
  }
};
ButtonSelect.contextType = ButtonGroupContext;
ButtonSelect.propTypes = {
  type: PropTypes2.oneOf(buttonSelectTypes).isRequired,
  selected: PropTypes2.bool,
  defaultSelected: PropTypes2.bool,
  disabled: PropTypes2.bool,
  name: PropTypes2.string,
  value: PropTypes2.oneOfType([PropTypes2.string, PropTypes2.number, PropTypes2.array]),
  size: PropTypes2.oneOf(buttonSelectSizes),
  onChange: PropTypes2.func,
  children: PropTypes2.node
};

// components/button/react/src/button-group/button-group.tsx
import { memo, useMemo, useEffect } from "react";
import PropTypes3 from "prop-types";
import {
  buttonGroupStyleSheet,
  getButtonGroupClassNames,
  defaultButtonGroupProps,
  buttonSizes as buttonSizes2,
  buttonGroupOrientations
} from "@gs-ux-uitoolkit-common/button";
import { useStyleSheet } from "@gs-ux-uitoolkit-react/style";
import { useTheme } from "@gs-ux-uitoolkit-react/theme";
import { jsx as jsx3 } from "react/jsx-runtime";
var ButtonGroup = memo((props) => {
  const _a = props, {
    size,
    name: name2,
    orientation = defaultButtonGroupProps.orientation,
    className,
    classes: overrideClasses
  } = _a, otherProps = __objRest(_a, [
    "size",
    "name",
    "orientation",
    "className",
    "classes"
  ]);
  useTheme();
  const cssClasses = useStyleSheet(buttonGroupStyleSheet, {
    orientation
  });
  const rootClasses = getButtonGroupClassNames({
    orientation,
    cssClasses,
    overrideClasses,
    className
  });
  const context = useMemo(() => ({ name: name2, size }), [name2, size]);
  useEffect(() => {
    componentAnalytics.trackRender({
      componentName: "button-group",
      officialComponentName: "other"
    });
  }, []);
  return jsx3(ButtonGroupContext.Provider, { value: context, children: jsx3(
    "div",
    __spreadProps(__spreadValues({}, otherProps), {
      className: rootClasses,
      "data-gs-uitk-component": "button-group",
      "data-orientation": orientation
    })
  ) });
});
ButtonGroup.displayName = "ButtonGroup";
ButtonGroup.propTypes = {
  name: PropTypes3.string,
  size: PropTypes3.oneOf(buttonSizes2),
  orientation: PropTypes3.oneOf(buttonGroupOrientations),
  className: PropTypes3.string
};
export {
  Button,
  ButtonGroup,
  ButtonSelect,
  Version,
  buttonActionTypes,
  buttonEmphasises2 as buttonEmphasises,
  buttonGroupOrientations2 as buttonGroupOrientations,
  buttonGroupStyleSheet2 as buttonGroupStyleSheet,
  buttonSelectSizes2 as buttonSelectSizes,
  buttonSelectStyleSheet2 as buttonSelectStyleSheet,
  buttonSelectTypes2 as buttonSelectTypes,
  buttonShapes2 as buttonShapes,
  buttonSizeVariants,
  buttonSizes3 as buttonSizes,
  buttonStatuses2 as buttonStatuses,
  buttonStyleSheet2 as buttonStyleSheet,
  buttonTypes2 as buttonTypes,
  defaultButtonGroupContext2 as defaultButtonGroupContext,
  defaultButtonGroupProps2 as defaultButtonGroupProps,
  defaultButtonProps2 as defaultButtonProps,
  defaultButtonSelectProps2 as defaultButtonSelectProps,
  getButtonClassNames2 as getButtonClassNames,
  getButtonGroupClassNames2 as getButtonGroupClassNames,
  getButtonSelectInputClassNames2 as getButtonSelectInputClassNames,
  getButtonSelectLabelClassNames2 as getButtonSelectLabelClassNames,
  getButtonSelectRootClassNames2 as getButtonSelectRootClassNames,
  getButtonSelectTargetClassNames2 as getButtonSelectTargetClassNames,
  getRootClassNames2 as getRootClassNames
};
//# sourceMappingURL=index.mjs.map
